import { Queue } from './queue';

export interface AnalyticsPluginOptions {
    serviceUrl: string;
    appId: string;
    maxRetryAttempts?: number;
}

export interface AnalyticsQueuedEvent {
    url: string;
    method: string;
    headers: Record<string, string>;
    body: AnalyticsTrackEvent;
}

export interface AnalyticsTrackEvent {
    event: string;
    timestamp: number;
    anonymousId: string;
    userId: string;
    properties: Record<string, any>;
}

function track(queue: Queue<AnalyticsQueuedEvent>, { payload, config }) {
    const { serviceUrl, appId } = config;
    const url = `${serviceUrl}/api/track`;
    const method = 'POST';
    const headers = {
        'Content-Type': 'text/plain',
    };
    const body = {
        appId,
        event: payload.event,
        timestamp: payload.meta.timestamp,
        anonymousId: payload.anonymousId,
        userId: payload.userId,
        properties: payload.properties,
    };

    queue.add({
        url, method, headers, body,
    });
}

export function createAnalyticsPlugin(options: AnalyticsPluginOptions) {
    const maxRetries = typeof options.maxRetryAttempts === 'number' ? options.maxRetryAttempts : 10;
    const queue = new Queue<AnalyticsQueuedEvent>(
        { maxRetries },
        item => fetch(item.url, {
            method: item.method,
            headers: item.headers,
            body: JSON.stringify(item.body),
        }),
    );

    return {
        name: 'pareto-analytics',
        config: options,
        initialize: () => {
            queue.start();
        },
        track: track.bind(null, queue),
    };
}
